import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pt_list",
  "use": "icon-pt_list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pt_list\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8.44,17.33H20v1.78H8.44Zm0-6.22H20v1.78H8.44ZM4,16.89H6.67v2.67H4Zm0-6.22H6.67v2.66H4ZM4,4.44H6.67V7.11H4Zm4.44.45H20V6.67H8.44Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol